import axios from 'axios';

export const groupLineApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/groups-line`,
    headers: {
        'Content-Type': 'application/json'
    }
})